import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import OverviewPage from "pages/OverviewPage";
import BucketsPage from "pages/BucketsPage";
// import useMicrofrontendCommunication from "hooks/useMicrofrontendCommunication";

export const AppRouter: React.FC = () => {
  // useMicrofrontendCommunication("/storage");

  return (
    <Routes>
      <Route path="/storage" element={<OverviewPage />} />
      <Route path="/storage/overview" element={<OverviewPage />} />
      <Route path="/storage/buckets" element={<BucketsPage />} />
      <Route path="*" element={<Navigate to="/storage" replace />} />{" "}
    </Routes>
  );
};

export default AppRouter;
